export const groupAppointmentLoading = ({store}) => store.groupAppointmentReducer.loading;
export const groupAppointmentData = ({store}) => store.groupAppointmentReducer.data;
export const groupAppointmentError = ({store}) => store.groupAppointmentReducer.error;
